import ccAPI from "@/api/creditControl";

const getDefaultState = () => ({
  
  creditControl: {},
  creditControlLoading: false,
  creditControlError: false,
  creditControlErrorResponse: null,

  updateQuickNoteLoading: false,
  updateQuickNoteError: false,
  updateQuickNoteErrorResponse: null,

  updateAccountLoading: false,
  updateAccountError: false,
  updateAccountErrorResponse: null,

  recoverFromHandedOverLoading: false,
  recoverFromHandedOverError: false,
  recoverFromHandedOverErrorResponse: null,

  creditControlHistory: {
    logs: [],
    config: {
      paginationCount: 0,
      paginationLimit: 10,
      paginationPage: 1
    }
  },
  creditControlHistoryLoading: false,
  creditControlHistoryError: false,
  creditControlHistoryErrorResponse: null,

  uddHistory: {
    logs: [],
    config: {
      paginationCount: 0,
      paginationLimit: 10,
      paginationPage: 1
    }
  },
  uddHistoryLoading: false,
  uddHistoryError: false,
  uddHistoryErrorResponse: null,

  saveExclusionLoading: false,
  saveExclusionError: false,
  saveExclusionErrorResponse: null,

  recoverFromDead01UddLoading: false,
  recoverFromDead01UddError: false,
  recoverFromDead01UddErrorResponse: null,

});

const state = getDefaultState();

const mutations = {
  
  FETCH_CREDIT_CONTROL_BEGIN(state){
    state.creditControlLoading = true;
    state.creditControlError = false;
    state.creditControlErrorResponse = null;
  },
  FETCH_CREDIT_CONTROL_SUCCESS(state,resp){
    state.creditControl = resp.data;
    state.creditControlLoading = false;
    state.creditControlError = false;
    state.creditControlErrorResponse = null;
  },
  FETCH_CREDIT_CONTROL_FAILED(state,error){
    state.creditControlLoading = false;
    state.creditControlError = true;
    state.creditControlErrorResponse = error;
  },

  UPDATE_QUICK_NOTE_BEGIN(state){
    state.updateQuickNoteLoading = true;
    state.updateQuickNoteError = false;
    state.updateQuickNoteErrorResponse = null;
  },
  UPDATE_QUICK_NOTE_SUCCESS(state,resp){
    state.creditControl = resp.data;
    state.updateQuickNoteLoading = false;
    state.updateQuickNoteError = false;
    state.updateQuickNoteErrorResponse = null;
  },
  UPDATE_QUICK_NOTE_FAILED(state,error){
    state.updateQuickNoteLoading = false;
    state.updateQuickNoteError = true;
    state.updateQuickNoteErrorResponse = error;
  },

  UPDATE_ACCOUNT_BEGIN(state){
    state.updateAccountLoading = true;
    state.updateAccountError = false;
    state.updateAccountErrorResponse = null;
  },
  UPDATE_ACCOUNT_SUCCESS(state,resp){
    state.creditControl = resp.data;
    state.updateAccountLoading = false;
    state.updateAccountError = false;
    state.updateAccountErrorResponse = null;
  },
  UPDATE_ACCOUNT_FAILED(state,error){
    state.updateAccountLoading = false;
    state.updateAccountError = true;
    state.updateAccountErrorResponse = error;
  },
  
  RECOVER_FROM_HANDED_OVER_BEGIN(state){
    state.recoverFromHandedOverLoading = true;
    state.recoverFromHandedOverError = false;
    state.recoverFromHandedOverErrorResponse = null;
  },
  RECOVER_FROM_HANDED_OVER_SUCCESS(state){
    state.recoverFromHandedOverLoading = false;
    state.recoverFromHandedOverError = false;
    state.recoverFromHandedOverErrorResponse = null;
  },
  RECOVER_FROM_HANDED_OVER_FAILED(state,error){
    state.recoverFromHandedOverLoading = false;
    state.recoverFromHandedOverError = true;
    state.recoverFromHandedOverErrorResponse = error;
  },
  
  FETCH_CREDIT_CONTROL_HISTORY_BEGIN(state) {
    state.creditControlHistoryLoading = true;
    state.creditControlHistoryError = false;
    state.creditControlHistoryErrorResponse = null;
  },
  FETCH_CREDIT_CONTROL_HISTORY_SUCCESS(state, payload) {
    state.creditControlHistoryLoading = false;
    state.creditControlHistory.logs = payload.results;
    state.creditControlHistory.config.paginationCount = payload.count;
  },
  FETCH_CREDIT_CONTROL_HISTORY_ERROR(state, error) {
    state.creditControlHistoryLoading = false;
    state.creditControlHistoryError = true;
    state.creditControlHistoryErrorResponse = error;
  },

  UPDATE_CREDIT_CONTROL_HISTORY_PAGINATION(state, payload) {
    state.creditControlHistory.config.paginationLimit = payload.itemsPerPage;
    state.creditControlHistory.config.paginationPage = payload.page;
  },

  FETCH_UDD_HISTORY_BEGIN(state) {
    state.uddHistoryLoading = true;
    state.uddHistoryError = false;
    state.uddHistoryErrorResponse = null;
  },
  FETCH_UDD_HISTORY_SUCCESS(state, payload) {
    state.uddHistoryLoading = false;
    state.uddHistory.logs = payload.results;
    state.uddHistory.config.paginationCount = payload.count;
  },
  FETCH_UDD_HISTORY_ERROR(state, error) {
    state.uddHistoryLoading = false;
    state.uddHistoryError = true;
    state.uddHistoryErrorResponse = error;
  },

  UPDATE_UDD_HISTORY_PAGINATION(state, payload) {
    state.uddHistory.config.paginationLimit = payload.itemsPerPage;
    state.uddHistory.config.paginationPage = payload.page;
  },

  SAVE_EXCLUSION_BEGIN(state) {
    state.saveExclusionLoading = true;
    state.saveExclusionError = false;
    state.saveExclusionErrorResponse = null;
  },
  SAVE_EXCLUSION_SUCCESS(state, payload) {
    state.saveExclusionLoading = false;
    state.creditControl = payload;
  },
  SAVE_EXCLUSION_ERROR(state, error) {
    state.saveExclusionLoading = false;
    state.saveExclusionError = true;
    state.saveExclusionErrorResponse = error;
  },

  RECOVER_FROM_DEAD_01_UDD_BEGIN(state) {
    state.recoverFromDead01UddLoading = true;
    state.recoverFromDead01UddError = false;
    state.recoverFromDead01UddErrorResponse = null;
  },
  RECOVER_FROM_DEAD_01_UDD_SUCCESS(state) {
    state.recoverFromDead01UddLoading = false;
  },
  RECOVER_FROM_DEAD_01_UDD_ERROR(state, err) {
    state.recoverFromDead01UddLoading = false;
    state.recoverFromDead01UddError = true;
    state.recoverFromDead01UddErrorResponse = err;
  },

  RESET_CREDIT_CONTROL_STORE(state) {
    Object.assign(state, getDefaultState());
  }
};

const actions = {

  async fetchCreditControl({ commit }, account_id) {
    commit("FETCH_CREDIT_CONTROL_BEGIN");
    try {
      const data = await ccAPI.fetchCreditControl(account_id);
      commit("FETCH_CREDIT_CONTROL_SUCCESS", data);
    } catch(error) {
      commit("FETCH_CREDIT_CONTROL_FAILED", error);
    }
  },

  async updateQuickNote({ commit,dispatch }, {account_id,note}) {
    commit("UPDATE_QUICK_NOTE_BEGIN");
    try {
      const data = await ccAPI.updateQuickNote(account_id,note);
      dispatch("alerts/setAlert", {type:"success",message:"Quick note updated successfully"}, { root: true });
      commit("UPDATE_QUICK_NOTE_SUCCESS", data);
    } catch(error) {
      if(error.response.status===403){
        dispatch("alerts/setAlert", {type:"error",message:error.response.data.detail}, { root: true });
      }else{
        dispatch("alerts/setAlert", {type:"error",message:error.response.data.quick_note[0]}, { root: true });
      }
      commit("UPDATE_QUICK_NOTE_FAILED", error);
    }
  },

  async updateAccount({ commit,dispatch }, {account_id,data}) {
    commit("UPDATE_ACCOUNT_BEGIN");
    try {
      const response = await ccAPI.updateAccount(account_id,data);
      dispatch("alerts/setAlert", {type:"success",message:"Account updated successfully"}, { root: true });
      commit("UPDATE_ACCOUNT_SUCCESS", response);
    } catch(error) {
      if(error.response.status===403){
        dispatch("alerts/setAlert", {type:"error",message:error.response.data.detail}, { root: true });
      }else{
        dispatch("alerts/setAlert", {type:"error",message:error.response.data.status[0]}, { root: true });
      }
      commit("UPDATE_ACCOUNT_FAILED", error);
    }
  },

  async recoverFromHandedOver({ commit,dispatch }, account_id) {
    commit("RECOVER_FROM_HANDED_OVER_BEGIN");
    try {
      await ccAPI.recoverFromHandedOver(account_id);
      dispatch('fetchCreditControl', account_id);
      dispatch("alerts/setAlert", {type:"success",message:"Account moved to Live"}, { root: true });
      commit("RECOVER_FROM_HANDED_OVER_SUCCESS");
    } catch(error) {
      dispatch("alerts/setAlert", {type:"error",message:error.response.data.detail}, { root: true });
      commit("RECOVER_FROM_HANDED_OVER_FAILED", error);
    }
  },

  async fetchCreditControlHistory({commit}, account_id) {
    commit('FETCH_CREDIT_CONTROL_HISTORY_BEGIN');
    try {
      const response = await ccAPI.fetchCreditControlHistory(account_id, state.creditControlHistory.config);
      commit('FETCH_CREDIT_CONTROL_HISTORY_SUCCESS', response.data);
    } catch(error) {
      commit('FETCH_CREDIT_CONTROL_HISTORY_ERROR', error.response.data.detail);
    }
  },

  updateCreditControlHistoryPagination({commit, dispatch}, payload) {
    commit('UPDATE_CREDIT_CONTROL_HISTORY_PAGINATION', payload.options);
    dispatch('fetchCreditControlHistory', payload.account_id);
  },

  async fetchUddHistory({commit}, account_id) {
    commit('FETCH_UDD_HISTORY_BEGIN');
    try {
      const response = await ccAPI.fetchUddHistory(account_id, state.uddHistory.config);
      commit('FETCH_UDD_HISTORY_SUCCESS', response.data);
    } catch(error) {
      commit('FETCH_UDD_HISTORY_ERROR', error.response.data.detail);
    }
  },

  updateUddHistoryPagination({commit, dispatch}, payload) {
    commit('UPDATE_UDD_HISTORY_PAGINATION', payload.options);
    dispatch('fetchUddHistory', payload.account_id);
  },
  
  async saveExclusion({commit, dispatch}, {account_id, payload}) {
    commit('SAVE_EXCLUSION_BEGIN');
    try {
      const response = await ccAPI.saveExclusion(account_id, payload);
      commit('SAVE_EXCLUSION_SUCCESS', response.data);
    } catch(error) {
      const message = error.response.status === 403 || error.response.status === 401 ? error.response.data.detail : error.response.data.exclusion_kind[0];   
      commit('SAVE_EXCLUSION_ERROR', message);
      dispatch('alerts/setAlert', {type: 'error', message}, { root: true });
    }
  },

  async recoverFromDead01Udd({ commit, dispatch }, account_id) {
    commit('RECOVER_FROM_DEAD_01_UDD_BEGIN');
    try {
      const data = await ccAPI.recoverFromDead01Udd(account_id);
      dispatch('alerts/setAlert', {type: 'success', message: data.data}, {root: true});
      commit('RECOVER_FROM_DEAD_01_UDD_SUCCESS');
    } catch(err) {
      let message = '';
      switch(err.response.status) {
        case 403:
          message = err.response.data.detail;
          break;
        case 409:
          message = err.response.data;
          break;
      }
      dispatch('alerts/setAlert', {type: 'error', message}, {root: true});
      commit('RECOVER_FROM_DEAD_01_UDD_ERROR', err);
    }
  }
};

const getters = {
  
  getCreditControl: state => state.creditControl,
  getCreditControlLoading: state => state.creditControlLoading,
  getCreditControlError: state => state.creditControlError,
  getCreditControlErrorResponse: state => state.creditControlErrorResponse,

  getUpdateQuickNoteLoading: state => state.updateQuickNoteLoading,
  getUpdateQuickNoteError: state => state.updateQuickNoteError,
  getUpdateQuickNoteErrorResponse: state => state.updateQuickNoteErrorResponse,

  getUpdateAccountLoading: state => state.updateAccountLoading,
  getUpdateAccountError: state => state.updateAccountError,
  getUpdateAccountErrorResponse: state => state.updateAccountErrorResponse,

  getRecoverFromHandedOverLoading: state => state.recoverFromHandedOverLoading,
  getRecoverFromHandedOverError: state => state.recoverFromHandedOverError,
  getRecoverFromHandedOverErrorResponse: state => state.recoverFromHandedOverErrorResponse,

  getCreditControlHistory: state => state.creditControlHistory,
  getCreditControlHistoryLoading: state => state.creditControlHistoryLoading,
  getCreditControlHistoryError: state => state.creditControlHistoryError,
  getCreditControlHistoryErrorResponse: state => state.creditControlHistoryErrorResponse,

  getUddHistory: state => state.uddHistory,
  getUddHistoryLoading: state => state.uddHistoryLoading,
  getUddHistoryError: state => state.uddHistoryError,
  getUddHistoryErrorResponse: state => state.uddHistoryErrorResponse,

  getSaveExclusionLoading: state => state.saveExclusionLoading,
  getSaveExclusionError: state => state.saveExclusionError,
  getSaveExclusionErrorResponse: state => state.saveExclusionErrorResponse,

  getRecoverFromDead01UddLoading: state => state.recoverFromDead01UddLoading,
  getRecoverFromDead01UddError: state => state.recoverFromDead01UddError,
  getRecoverFromDead01UddErrorResponse: state => state.recoverFromDead01UddErrorResponse,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
